<template>
  <div v-click-outside="hideProfile">
    <div class="bb-profile">
      <img class="bb-profile__avatar"
           :src="userImage"
           @click="profileOpen()"
      />
      <transition name="fade">
        <span v-if="sidebarOpen"
              class="bb-profile__name"
              @click="openUserCard()"
        >
          {{userInfo.username}}
        </span>
      </transition>
    </div>
    <transition name="fade">
      <div
        v-if="statusProfile && userInfo"
        class="bb-profile-full"
      >
        <div class="bb-profile-full-left">
          <div class="bb-profile-full-left__avatar_wrapper">
            <img class="bb-profile-full-left__avatar" :src="userImage"/>
          </div>
          <div class="bb-profile-full-left__role">{{getNameRole(userInfo.role)}}</div>
        </div>
        <div class="bb-profile-full-right">
          <div class="bb-profile-top">
            <div class="bb-profile-top__name">{{userInfo.username}}</div>
            <div class="bb-profile-top-icons">
              <span class="bb-profile-top-icons__user-card"
                    @click="openUserCard()"
              >
                <div v-html="userIcon()"/>
              </span>
              <img src="../../../assets/images/logout.png"
                   class="bb-profile-top-icons__logout"
                   @click="logOut()">
            </div>
          </div>
          <ul class="bb-profile-info">
            <li class="bb-profile-info__item" v-if="userInfo.phone">
              <span class="bb-profile-info__title">Phone:</span>
              {{userInfo.phone}}
            </li>
            <li class="bb-profile-info__item" v-if="userInfo.email">
              <span class="bb-profile-info__title">Email:</span>
              {{userInfo.email}}
            </li>
            <li class="bb-profile-info__item" v-if="userInfo.position">
              <span class="bb-profile-info__title">Position:</span>
              {{userInfo.position ? userInfo.position.name : ''}}
            </li>
          </ul>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import avatarUserDefault from '../../../assets/images/avatar-user-default-big.png'
import {ROLES_LIST} from '@/constants/roles'
import ClickOutside from 'vue-click-outside'
import {UserIcon} from '../../../constants/icon'
import GmailApi from '@/api/Gmail/api'

export default {
  name: 'Profile',
  props: {sidebarOpen: Boolean},
  directives: {
    ClickOutside
  },
  data () {
    return {
      statusProfile: false,
      userIcon: UserIcon
    }
  },
  computed: {
    userImage: function () {
      return this.userInfo.image ? this.userInfo.image.path : avatarUserDefault
    },
    userInfo: {
      get: function () {
        return this.$store.getters.userInfo
      },
      set: function (data) {
        this.$store.dispatch('setUserInfo', data)
      }
    },
    isShowTimerPanel: {
      get () {
        return this.$store.getters.isShowTimerPanel
      },
      set (data) {
        this.$store.dispatch('setShowTimer', data)
      }
    }
  },
  methods: {
    getNameRole (valueRole) {
      const role = ROLES_LIST.find(item => item.id === valueRole)
      return role ? role.name : ''
    },
    profileOpen: function () {
      this.statusProfile = true
    },
    openUserCard: function () {
      const {id, isHrIncluded} = this.userInfo
      this.hideProfile()
      if (isHrIncluded) {
        this.$emit('updateActiveMenu', true)
        this.$router.replace({
          name: 'EmployeesCard',
          params: { id, tab: 'salary', nameRouteChildren: 'salary' }
        })
          .catch(err => err)
      } else {
        this.$emit('updateActiveMenu', false)
        this.$router.push({name: 'UserCard', params: {id: id}}).catch(err => err)
      }
    },
    async logOut () {
      const { email } = this.userInfo
      try {
        await GmailApi.gmailActionsLogout({ email });
      } catch (err) {
        console.error(err)
      } finally {
        this.isShowTimerPanel = false;
        this.$cookie.delete('googleToken');
        this.$cookie.delete('token');
        this.$cookie.delete('company');
        this.$store.commit('resetStore');
        this.$router.push({'name': 'SingIn'});
      }
    },
    hideProfile: function () {
      this.statusProfile = false
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/transition";
  @import "../../../sass/mixins";

  .bb-profile {
    @include global-font;
    position: relative;
    display: flex;
    align-items: center;
    min-width: 81px;
    max-width: 279px;
    padding: 0 21px 0;
    margin-top: 38px;
    cursor: pointer;
    user-select: text;

    &__avatar {
      width: 39px;
      height: 39px;
      border-radius: 50%;
    }

    &__name {
      text-transform: capitalize;
      margin-left: 15px;
      font-size: 14px;
      line-height: 17px;
      color: $color-white;
      white-space: nowrap;
    }

    &-full {
      position: fixed;
      left: 72px;
      top: 38px;
      display: flex;
      border-radius: 5px;
      background-color: $color-white;
      padding: 25px 14px 17px 32px;
      z-index: 99999;
      min-width: 520px;
      box-shadow: 0 0 10px rgba($color-black, 0.1);

      &:before {
        position: absolute;
        top: 15px;
        left: -10px;
        content: '';
        border: 5px solid transparent;
        border-right: 5px solid $color-white;
      }

      &-left {
        display: flex;
        justify-content: center;
        flex-direction: column;
        margin-right: 58px;

        &__avatar_wrapper {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }

        &__avatar {
          border-radius: 50%;
          width: 129px;
          height: 129px;
        }

        &__role {
          text-align: center;
          color: $color-denim;
          font-size: 12px;
          line-height: 14px;
          padding: 7px 7px;
          margin: 13px auto 0 auto;
          background-color: $color-wild-sand;
          border-radius: 5px;
        }

        &__edit-avatar {
          width: 26px;
          height: 26px;
          margin-top: -16px;
          cursor: pointer;
        }
      }

      &-right {
        width: 100%
      }
    }

    &-top {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 20px;

      &-icons {
        display: flex;
        justify-content: space-between;
        align-items: center;
        max-width: 64px;
        width: 100%;

        &__user-card {
          width: 28px;
          height: 28px;
          cursor: pointer;
          transition: all .2s ease-out;
        }

        &__logout {
          width: 28px;
          height: 28px;
          cursor: pointer;
        }
      }

      &__name {
        text-transform: capitalize;
        font-size: 20px;
        line-height: 24px;
      }
    }

    &-info {
      font-size: 14px;
      line-height: 17px;

      &__item {
        margin: 15px 0;
      }

      &__title {
        margin-right: 6px;
        color: $color-accent;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/Profile/Profile.vue